import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'tdv-icon-goal-wrap',
  templateUrl: './icon-goal-wrap.component.html',
  styleUrls: ['./icon-goal-wrap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconGoalWrapComponent {}
